import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalHomeRoutingModule } from './portal-home-routing.module';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { SharedModule } from '../shared/shared.module';
import { LoginHomeComponent } from './login-home/login-home.component';
import { LoginPatientComponent } from './login-patient/login-patient.component';
import { LoginHealthCareProfComponent } from './login-health-care-prof/login-health-care-prof.component';
import { RegisterPatientComponent } from './register-patient/register-patient.component';
import { ForgetPasswordPatientComponent } from './forget-password-patient/forget-password-patient.component';
import { ForgetPasswordHealthCareProfComponent } from './forget-password-health-care-prof/forget-password-health-care-prof.component';
import { ForgetEmailPatientComponent } from './forget-email-patient/forget-email-patient.component';
import { ForgetEmailHealthCareProfComponent } from './forget-email-health-care-prof/forget-email-health-care-prof.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginOptionsComponent } from './login-options/login-options.component';
import { RegisterDoctorComponent } from './register-doctor/register-doctor.component';
import { UtilitiesModule } from '../shared/utilities/utilities.module';
import { VerifyUseridPatientComponent } from './verify-userid-patient/verify-userid-patient.component';
import { ApyayaOtpComponent } from './apyaya-otp/apyaya-otp.component';
import { AdLandingPageComponent } from './ad-landing-page/ad-landing-page.component';
import { ConsultationFlowComponent } from './consultation-flow/consultation-flow.component';
import { MultiSpecialityConsultationComponent } from './multi-speciality-consultation/multi-speciality-consultation.component';
import { ExpertSecondMedicalOpinionComponent } from './expert-second-medical-opinion/expert-second-medical-opinion.component';
import { InvoiceModule } from '../shared/invoice/invoice.module';
import { ProviderRegistrationComponent } from './provider-registration/provider-registration.component';


@NgModule({
    declarations: [
        LoginHomeComponent,
        LoginPatientComponent,
        LoginHealthCareProfComponent,
        RegisterPatientComponent,
        ForgetPasswordPatientComponent,
        ForgetPasswordHealthCareProfComponent,
        ForgetEmailPatientComponent,
        ForgetEmailHealthCareProfComponent,
        ResetPasswordComponent,
        LoginOptionsComponent,
        RegisterDoctorComponent,
        VerifyUseridPatientComponent,
        ApyayaOtpComponent,
        AdLandingPageComponent,
        ConsultationFlowComponent,
        MultiSpecialityConsultationComponent,
        ExpertSecondMedicalOpinionComponent,
        ProviderRegistrationComponent,
    ],
    imports: [
        CommonModule,
        PrimengModule,
        PortalHomeRoutingModule,
        SharedModule,
        UtilitiesModule,
        InvoiceModule
    ],
})
export class PortalHomeModule { }
